<template>
  <v-card flat>
    <v-container>
      <line-chart :chart-data="datacollection" :options="options"></line-chart>
    </v-container>
  </v-card>
</template>

<script>
import LineChart from "./LineChart.js";
export default {
  name: "AQIChartComponent",
  components: {
    LineChart
  },
  data() {
    return {
      datacollection: {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ],
        datasets: [
          {
            label: `Earnings`,
            data: [],
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(255, 159, 64, 0.2)",
              "rgba(255, 205, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(201, 203, 207, 0.2)"
            ]
          }
        ]
      },
      chartOptions: {
        // responsive: true,
        // legend: {
        //   display: true,
        // },
        // tooltips: {
        //   titleFontSize: 20,
        //   bodyFontSize: 25,
        // },
        // scales: {
        //   xAxes: [],
        //   yAxes: [
        //     {
        //       ticks: {
        //         beginAtZero: true,
        //       },
        //     },
        //   ],
        // },
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                steps: 10,
                stepValue: 100,
                max:100000,
                callback: value => value
              }
            }
          ],
          xAxes: [{}]
        }
      }
    };
  },
  props: {
    userData: {
      type: [Object,String]
    }
  },

  created() {},

  methods: {}
};
</script>
